/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  message,
  Radio,
  Modal,
  Space,
  Spin,
  Typography,
  Popconfirm,
} from "antd";
import RateCharges from "./RateCharges";
import CashRate from "./CashRate";
import API from "../../../api";
import urls from "../../../api/urls";
import { useParams } from "react-router";
// import Heading from "../../Heading";
import useCustomNavigate from "../../../components/customNavigationHook";
import { capitaliseWithHyphen } from "../../../utils";
import RateComission from "./RateComission";

const { LEAD_APPROVAL, GET_RATE_CARD_APPROVAL } = urls;
import { customerOnboardingAPI } from "../../../api/LeadApi";

const CashQuotation = ({ cashData, navigateId, accountPresent, changeTab }) => {
  let params = useParams();
  const navigate = useCustomNavigate();
  const { TextArea } = Input;
  const { Title } = Typography;
  const [form] = Form.useForm();
  const [quotationRateCharges, setquotationRateCharge] = useState([]);
  const [quotationRateMatrixCash, setQuotationRateMatrixCash] = useState({});

  const [quotationData, setQuotationData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [inputText, setInputText] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rateCommission, setRateCommission] = useState({});
  const rateType = "CASH";
  const rejectList = [
    {
      label: "Conflict with existing CP Network",
      value: "Conflict with existing CP Network",
    },
    {
      label: "Lack of commitment enthusiasm",
      value: "Lack of commitment enthusiasm",
    },
    {
      label: "Failed to pass due diligence check",
      value: "Failed to pass due diligence check",
    },
    {
      label: "Lack of industry experience",
      value: "Lack of industry experience",
    },
    {
      label: "Insufficient financial resources",
      value: "Insufficient financial resources",
    },
    { label: "others", value: "others" },
  ];

  // const showApprove =
  //   quotationData?.approvalStatus?.toUpperCase() === "PENDING" &&
  //   history?.state?.type === "ho-lead";

  useEffect(() => {
    getQuotationDetail();
  }, [cashData]);

  const getQuotationDetail = async () => {
    const data = cashData?.data;
    const oldData = data?.rateCard_old;
    setQuotationData(data);
    setRateCommission({
      current: data?.commission,
      past: oldData?.commission,
    });
    form.setFieldsValue({
      fromDate: data?.fromDate,
      toDate: data?.toDate,
      billingCycle: capitaliseWithHyphen(data?.billingCycle),
      invoiceType: capitaliseWithHyphen(data?.invoiceType),
      type: data?.type,
      commitedBusiness: data?.commitedBusiness,
    });
    setquotationRateCharge({
      current: data?.charges,
      past: data?.charges_old || null,
    });
    data?.rates?.forEach((item) => {
      switch (item?.type) {
        case "CASH":
          setQuotationRateMatrixCash(item?.rate);
          break;
        default:
          break;
      }
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setValue(null);
    setInputText(null);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    let val = value === "others" ? inputText : value;

    if (val) {
      setLoading(true);
      let payload = {
        quotations: [
          {
            rateCardType: rateType,
            rateCardName: cashData?.data?.name,
            status: "REJECTED",
            remark: val,
          },
        ],
      };
      let res = await customerOnboardingAPI.patchLead(params?.leadId, payload);
      if (res?.status) {
        setLoading(false);
        if (accountPresent) {
          changeTab("2");
          window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
        } else {
          navigate("/all-approvals", { state: navigateId });
        }
        setIsModalOpen(false);
      } else {
        setLoading(false);
        message.error(res?.response?.data?.message || "Internal server error");
        setIsModalOpen(false);
      }
    } else {
      message.error("Please select an option or enter a remark");
    }
  };

  const onRejectChange = (e) => {
    setValue(e.target.value);

    setInputText(null);
  };

  const approveLead = async () => {
    setLoading(true);
    let payload = {
      quotations: [
        {
          rateCardType: rateType,
          rateCardName: cashData?.data?.name,
          status: "APPROVED",
        },
      ],
    };
    //let res = await API.Api(`${LEAD_APPROVAL}`).putCustomIdHeader(payload);
    let response = await customerOnboardingAPI.patchLead(
      params?.leadId,
      payload
    );
    if (response?.status) {
      setLoading(false);
      message.success(response?.response?.data?.message);
      if (accountPresent) {
        changeTab("2");
        window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
      } else {
        navigate("/all-approvals", { state: navigateId });
      }
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };
  return (
    <div className="master-main-container p-1">
      {/* <Heading
        title={`${cashData?.data?.name || ""}${
          cashData?.isPending ? " Approval Confirmation" : ""
        }`}
        id={1}
      /> */}
      <Title level={4}>
        {cashData?.data?.name || ""} ({cashData?.data?.approvalStatus})
      </Title>
      <Spin spinning={loading}>
        <Form
          className="global-form"
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
        >
          <Row className="global-form-row p-1" gutter={20}>
            {/* <Col span={2} /> */}
            <Col className="form-inputs" span={8}>
              <Form.Item name="fromDate" label="Start Date">
                {quotationData?.rateCard_old &&
                quotationData?.fromDate !==
                  quotationData?.rateCard_old?.fromDate ? (
                  <div className="disable-div">
                    <span className="high-light">
                      {capitaliseWithHyphen(quotationData?.fromDate)}

                      <span className="past-val ml-05">
                        {capitaliseWithHyphen(
                          quotationData?.rateCard_old?.fromDate
                        )}
                      </span>
                    </span>
                  </div>
                ) : (
                  <Input disabled />
                )}
              </Form.Item>
            </Col>
            <Col className="form-inputs" span={8}>
              <Form.Item name="toDate" label="End Date">
                {quotationData?.rateCard_old &&
                quotationData?.toDate !==
                  quotationData?.rateCard_old?.toDate ? (
                  <div className="disable-div">
                    <span className="high-light">
                      {capitaliseWithHyphen(quotationData?.toDate)}

                      <span className="past-val ml-05">
                        {capitaliseWithHyphen(
                          quotationData?.rateCard_old?.toDate
                        )}
                      </span>
                    </span>
                  </div>
                ) : (
                  <Input disabled />
                )}
              </Form.Item>
            </Col>
            {/* <Col span={2} />
            <Col span={2} /> */}

            <Col className="form-inputs" span={8}>
              <Form.Item name="billingCycle" label="Billing Cycle">
                {quotationData?.rateCard_old &&
                quotationData?.billingCycle !==
                  quotationData?.rateCard_old?.billingCycle ? (
                  <div className="disable-div">
                    <span className="high-light">
                      {capitaliseWithHyphen(quotationData?.billingCycle)}

                      <span className="past-val ml-05">
                        {capitaliseWithHyphen(
                          quotationData?.rateCard_old?.billingCycle
                        )}
                      </span>
                    </span>
                  </div>
                ) : (
                  <Input disabled />
                )}
              </Form.Item>
            </Col>
            <Col className="form-inputs" span={8}>
              <Form.Item name="invoiceType" label="Invoice Type">
                {quotationData?.rateCard_old &&
                quotationData?.invoiceType !==
                  quotationData?.rateCard_old?.invoiceType ? (
                  <div className="disable-div">
                    <span className="high-light">
                      {capitaliseWithHyphen(quotationData?.invoiceType)}

                      <span className="past-val ml-05">
                        {capitaliseWithHyphen(
                          quotationData?.rateCard_old?.invoiceType
                        )}
                      </span>
                    </span>
                  </div>
                ) : (
                  <Input disabled />
                )}
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item name="commitedBusiness" label="Commited Business">
                {quotationData?.rateCard_old &&
                quotationData?.commitedBusiness !==
                  quotationData?.rateCard_old?.commitedBusiness ? (
                  <div className="disable-div">
                    <span className="high-light">
                      {capitaliseWithHyphen(quotationData?.commitedBusiness)}
                      <span className="past-val ml-05">
                        {capitaliseWithHyphen(
                          quotationData?.rateCard_old?.commitedBusiness
                        )}
                      </span>
                    </span>
                  </div>
                ) : (
                  <Input disabled />
                )}
              </Form.Item>
            </Col>
          </Row>
          <div>
            <RateComission commission={rateCommission} />
            <RateCharges quotationRateCharge={quotationRateCharges} />
            <CashRate quotationRateMatrix={quotationRateMatrixCash} />
          </div>
          {cashData?.isPending && (
            <div className="flex-end m-1">
              <Button
                className="btn-style cancel-btn w-10"
                // onClick={cancelTemlate}
                onClick={() => showModal()}
              >
                REJECT
              </Button>
              <Popconfirm
                title="Approve Rate Card"
                description="Are you sure you want to approve this rate card?"
                onConfirm={() => approveLead()}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  htmlType="submit"
                  className="save-btn ml-1"
                  id="saveNContinue"
                >
                  APPROVE
                </Button>
              </Popconfirm>
            </div>
          )}
        </Form>
      </Spin>
      <Modal
        title="Reason for rejection"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Radio.Group onChange={onRejectChange} value={value}>
          <Space direction="vertical">
            {rejectList?.map((item, i) => (
              <Radio key={i} value={item.value}>
                {item.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {value === "others" && (
          <div style={{ marginTop: "20px" }}>
            <div>Remarks</div>
            <TextArea
              className="input-field-style"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              style={{
                borderRadius: "10px",
                minWidth: "250px",
              }}
              placeholder="Please enter remarks"
              autoSize={{
                minRows: 3,
                maxRows: 5,
              }}
            />
          </div>
        )}
      </Modal>
    </div>
  );
};
export default CashQuotation;
